<template>
  <div class="pageWuaRecharge">
    <XR-head titleText="WUA充值" :rightShow="false"></XR-head>    
    <div class="total account-address">
      <p class="title">充值需知：</p>
      <p class="desc">如有充值问题，请联系：{{siteConfigInfo.Phone}}或QQ：{{siteConfigInfo.QQ}}。</p>
      <p class="tip">请打开智联资产钱包商城充值页面，给以下地址充值即可</p>
      <p class="address">{{wuaInfo.CoinAddress}}</p>
      <p class="copybtn">复制地址</p>
    </div>
    <XR-toast ref="XRtoast"></XR-toast>
  </div>
</template>

<script>
import siteconfig from '../../util/siteconfigCache'
export default {
  data() {
    return {
      siteConfigInfo: {},
      wuaInfo: {}
    };
  },
  mounted :function(){
    this.$refs.XRtoast.load()
    this.siteConfigInfo = siteconfig.getSiteconfig()
    this.getWuaInfo()
  },
  methods: {
    getWuaInfo: function() {
      var ths = this;   
      ths.$post(
        "/Shop/UserServer/GetWuaAccountInfo"
      ).then(function(res) {
        if(!res.IsSuccess){          
          if(res.TypeId == 1){
            ths.$router.push("/usercenter/wuaActive")
          }
          if(res.TypeId == ErrorCode.SessionMissing){
            ths.$router.push("/Login")
          }
        }else{          
          ths.wuaInfo = res.Data;
          ths.loaded=false
          ths.$refs.XRtoast.hide()
        }
      });
    }
  }
};
</script>
<style>
#app .pageWuaRecharge{
  bottom: 0;
  background: white;
}
.pageWuaRecharge .total{
  background: white;
  padding: 20px 20px;
}
.pageWuaRecharge .title{
  line-height: 24px;
  font-size: 14px;
  color:red;
}
.pageWuaRecharge .account-address .desc{    
  padding: 10px 0 0;
  font-size: 12px;
  color:#999;
}
.pageWuaRecharge .account-address .tip{    
  padding: 10px 0 0;
  font-size: 12px;
  padding: 30px 0 0;
}
.pageWuaRecharge .money{
  font-size: 46px;
  color:red;
  line-height: 42px;
  padding: 10px 0 10px;
  letter-spacing: -1px;
}
.pageWuaRecharge .account-address{
  margin-bottom: 10px;
}
.pageWuaRecharge .account-address .address {
  font-size:12px;
  color:black;
  background:#efefef;
  margin: 20px 0;
  height:50px;
  line-height:50px;
  text-align: center;
}
.pageWuaRecharge .account-address .copybtn{
  text-align: center;
  font-size: 12px;
  color:Red;
}
</style>



// WEBPACK FOOTER //
// src/pages/usercenter/wuaRecharge.vue